import { Pipe, PipeTransform } from '@angular/core';
import { Incident, User } from 'src/api/models';

@Pipe({
  name: 'incidentpipe',
  pure: false
})
export class IncidentPipe implements PipeTransform {

  transform(incidents: Incident[], statusTypeId: number, siteId: number): Incident[] | undefined {
    if (incidents) {
      return incidents.filter(id => id.status.statusId == statusTypeId &&  (siteId == 0 || siteId == null || id.site.siteId == siteId));
    }
    return null;
  }

}
